import * as config from '../app/config/config';

export const environment = {
    production: false,
    auth0Config: {
      clientID: 'hL8bLDHpGXPQIfvCkSq7Kz2R5vs6z5Mb',
      domain: 'mycareplan-dev.auth0.com',
      responseType: 'token id_token',
      redirectUri: 'https://admin.test.mycareplan.health/callback/',
      audience: 'https://mycareplan.health/api/v1/',
      scope: 'openid email profile read:current_user update:current_user_identities firebase ' + config.getScope()
    },
    firebaseConfig: {
      apiKey: "AIzaSyDSheQDE33m1ACWWH93VC8fUn1RN3cLTCw",
      authDomain: "cc-deploy-onehealth-dev.firebaseapp.com",
      databaseURL: "https://cc-deploy-onehealth-dev.firebaseio.com",
      projectId: "cc-deploy-onehealth-dev",
      storageBucket: "cc-deploy-onehealth-dev.appspot.com",
      messagingSenderId: "71657680916",
      appId: "1:71657680916:web:2851f6a9042fceb7773701"
    },
    yellowfin: {
      url: "https://insights.test.mycareplan.health"
    },
    baseUrl: {
      campaign: "https://campaign-service.test.mycareplan.health/",
      offer: "https://offer-service.test.mycareplan.health/",
      reward: "https://reward-service.test.mycareplan.health/",
      patient: "https://patient-service.test.mycareplan.health/",
      note: "https://patient-service.test.mycareplan.health/",
      queue: "https://dashboard-service.test.mycareplan.health/",
      board: "https://dashboard-service.test.mycareplan.health/",
      task: "https://dashboard-service.test.mycareplan.health/",
      label: "https://dashboard-service.test.mycareplan.health/",
      message: "https://communication-service.test.mycareplan.health/",
      shorten: "https://communication-service.test.mycareplan.health/",
      template: "https://dashboard-service.test.mycareplan.health/",
      questionnaire: "https://questionnaire-service.test.mycareplan.health/",
      media: "https://patient-service.test.mycareplan.health/",
      form: "https://patient-service.test.mycareplan.health/",
      drawing: "https://drawing-service-avzqsywjlq-uc.a.run.app/",
      awardRule: "https://drawing-service.test.mycareplan.health/",
      sviapi: "https://us-central1-mycareplan-dev.cloudfunctions.net/",
      peopleapi: "https://us-central1-mycareplan-dev.cloudfunctions.net/",
      ethnicity: "https://us-central1-mycareplan-dev.cloudfunctions.net/",
      ZipCodeApi: "https://us-central1-mycareplan-dev.cloudfunctions.net/",
      dashboard: "https://www.chirpn.xyz/customer/",
      signup: "https://www.chirpn.xyz/login/",
      offers: "https://www.chirpn.xyz/api/",
      bookings:"https://www.chirpn.xyz/api/",
      token: "https://www.chirpn.xyz/oauth/",
    },
    sidebarLogoUrl: "assets/images/background/sidebar-logo.png",
    tenant: {
      logo: "",
      name: ""
    },
    communicationReadTime: "7" // days
    // patientIdUrl: 'https://app.onehealth.test.mycareplan.health/patient_id'
  };
  export const openUrls = [
    `${environment.baseUrl.dashboard}dashboard`,
    `${environment.baseUrl.signup}signup`,
    `${environment.baseUrl.offers}offers`,
    `${environment.baseUrl.bookings}bookings`,
    `${environment.baseUrl.token}token`
  ];